export default "/images/a111c735277ddd3987dfc8f65a585540.avif";